import { render, staticRenderFns } from "./StorageSpaces.vue?vue&type=template&id=c3ac1880&"
import script from "./StorageSpaces.vue?vue&type=script&lang=js&"
export * from "./StorageSpaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports